export const AppData = Object.freeze({
  AuthToken: 'token',
});
